import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import classNames from 'classnames';

import { toggleSelectTask } from '../../bundles/tasks/index/store/actions/select_list';
import { updatePreviewData } from '../../bundles/tasks/index/store/actions/ui';

import { valueOrPlaceholder } from 'helpers/string_helpers';

import dueDate from '../../bundles/tasks/index/due_date';
import ProfilePhoto from './profile_photo';
import TaskCheckbox from './task_checkbox';

export class CallListTaskRow extends React.Component {
  static propTypes = {
    completed: PropTypes.bool.isRequired,
    contactPreviewProps: PropTypes.shape({
      displayActions: PropTypes.shape({
        slideOpen: PropTypes.string
      }).isRequired
    }).isRequired,
    isMobile: PropTypes.bool.isRequired,
    previewOverlayCallId: PropTypes.bool,
    previewOverlayCallListId: PropTypes.number,
    renderTaskDropdown: PropTypes.func.isRequired,
    selectedIds: PropTypes.array.isRequired,
    task: PropTypes.shape({
      assignees: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        profilePhotoUrl: PropTypes.string.isRequired
      })).isRequired,
      associatedModels: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string.isRequired
      })).isRequired,
      completed: PropTypes.bool,
      id: PropTypes.number.isRequired,
      taskType: PropTypes.string
    }).isRequired,
    updatePreviewData: PropTypes.func.isRequired,
    onHandleTaskEdit: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    onToggleTaskState: PropTypes.func.isRequired
  }

  associatedModel(associatedModel) {
    const { task: { associatedModels } } = this.props;
    const filteredModels = associatedModels.filter(association => association.associatedModelType === associatedModel);
    const originalModel = filteredModels.find(association => association.associatedModelId === association.originalId);

    return originalModel || filteredModels[0];
  }

  canPreview = () => {
    const {
      previewOverlayCallId,
      previewOverlayCallListId
    } = this.props;

    return !(previewOverlayCallId || previewOverlayCallListId);
  };

  handleUpdatePreviewOverlay = (associatedModel) => {
    const contact = this.associatedModel(associatedModel);
    if (!this.canPreview() || !contact) return null;

    const {
      task: { id },
      contactPreviewProps,
      updatePreviewData
    } = this.props;

    const { displayActions: { slideOpen } } = contactPreviewProps;
    const person = this.associatedModel(associatedModel);

    updatePreviewData(person.associatedModelId, associatedModel, id);
    window[slideOpen]();
    sessionStorage.setItem("previewDisplay", true);
  };

  renderPreviewButton(associatedModel) {
    const contact = this.associatedModel(associatedModel);
    if (!this.canPreview() || !contact) return;

    return (
      <button
        className="btn btn-sm btn-hover btn-muted"
        onClick={() => this.handleUpdatePreviewOverlay(associatedModel)}
      >
        PREVIEW
      </button>
    );
  }

  renderAssociatedPerson() {
    const {
      isMobile,
      task,
      onHandleTaskEdit
    } = this.props;

    const association = this.associatedModel("Contacts::Person");
    const name = association ? association.name : null;

    return (
      <td className="clickable fs-14" onClick={() => onHandleTaskEdit(task, isMobile)}>
        <b>{valueOrPlaceholder(name)}</b>
      </td>
    );
  }

  renderAssociatedCompany() {
    const {
      isMobile,
      task,
      onHandleTaskEdit
    } = this.props;

    const association = this.associatedModel("Contacts::Company");
    const name = association ? association.name : null;

    return (
      <td className="clickable fs-14" onClick={() => onHandleTaskEdit(task, isMobile)}>
        <b>{valueOrPlaceholder(name)}</b>
      </td>
    );
  }

  renderAssociatedProperty() {
    const association = this.associatedModel("Research::Property");
    const name = association ? association.name : null;

    let content = (
      <div className="task-text">
        {valueOrPlaceholder(name)}
      </div>
    );

    if (association) {
      content = (
        <a href={association.url}>
          {valueOrPlaceholder(name)}
        </a>
      );
    }

    return (
      <td className="fs-14">
        {content}
      </td>
    );
  }

  isSelected(TaskId) {
    const { selectedIds } = this.props;
    return selectedIds.indexOf(TaskId) > -1;
  }

  handleSelect = () => {
    const { task, onSelect } = this.props;
    if (onSelect != null) {
      onSelect(task);
    }
  };

  render() {
    const {
      completed,
      task,
      renderTaskDropdown,
      onToggleTaskState
    } = this.props;

    return (
      <tr className={classNames('task', { 'task-completed': completed })}>
        <td>
          <input
            checked={this.isSelected(task.id)}
            className="checkbox--lg"
            name="select-checkbox"
            type="checkbox"
            onChange={this.handleSelect}
          />
        </td>
        <td className="task-checkbox">
          <TaskCheckbox size="20px" task={task} onClick={onToggleTaskState} />
        </td>
        {this.renderAssociatedPerson()}
        <td>{this.renderPreviewButton("Contacts::Person")}</td>
        {this.renderAssociatedCompany()}
        <td>{this.renderPreviewButton("Contacts::Company")}</td>
        <td className="clickable fs-14">
          <div className="task-text">
            {task.title || task.body}
          </div>
        </td>
        {this.renderAssociatedProperty()}
        <td className="profile-image">
          <ProfilePhoto photoUrl={task.ownerImageUrl} value={task.owner} />
        </td>
        <td className="profile-image">
          <ProfilePhoto photoUrl={task.assigneeImageUrl} value={task.assignee} />
        </td>
        <td className="clickable">
          {dueDate(task)}
        </td>
        <td>
          {renderTaskDropdown(task)}
        </td>
      </tr>
    );
  }
}

const mapStateToProps = state => ({
  contactPreviewProps: state.ui.contactPreviewProps,
  previewOverlayCallId: state.ui.previewOverlayCallId,
  previewOverlayCallListId: state.ui.previewOverlayCallListId,
  selectedIds: state.selectList.selectedTaskIds
});

const mapDispatchToProps = {
  updatePreviewData,

  onSelect: toggleSelectTask
};

export default connect(mapStateToProps, mapDispatchToProps)(CallListTaskRow);
